import { render, staticRenderFns } from "./GroupsAndAttributes.vue?vue&type=template&id=09d9f102"
import script from "./GroupsAndAttributes.vue?vue&type=script&lang=js"
export * from "./GroupsAndAttributes.vue?vue&type=script&lang=js"
import style0 from "./GroupsAndAttributes.vue?vue&type=style&index=0&id=09d9f102&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports